export const getDiscordOauthUrl = () => {
    if(process.env.NODE_ENV === 'development'){
        return 'https://discord.com/oauth2/authorize?client_id=1239216942662029405&response_type=code&redirect_uri=http%3A%2F%2F127.0.0.1%3A5001%2Fodyssey-442a0%2Feurope-west3%2Fqualifier-discordAuth&scope=identify';
    }
    return 'https://discord.com/oauth2/authorize?client_id=1239216942662029405&response_type=code&redirect_uri=https%3A%2F%2Fqualifier-discordauth-jhrxgy3voq-ey.a.run.app&scope=identify';
}
